import Resizer from 'react-image-file-resizer';

export const profileImage = (guest) => {
  if (guest.photo) return guest.photo;
  if (guest.gender === 'Masculino')
    return 'https://react.semantic-ui.com/images/avatar/small/matthew.png';
  if (guest.gender === 'Femenino')
    return 'https://react.semantic-ui.com/images/avatar/small/lindsay.png';
};

const IMAGE_EXTS = ['jpg', 'jpeg', 'png'];

export const resizeImageFile = (file, { maxWidth = 450, maxHeight = 450, quality = 100 } = {}) =>
  new Promise((resolve, reject) => {
    const ext = String(file?.name || '')
      .split('.')
      .pop()
      .toLowerCase();
    if (!IMAGE_EXTS.includes(ext)) {
      reject(new Error('Solo puedes subir imagenes en JPG, JPEG o PNG'));
      return;
    }
    if (file.size > 5000000) {
      reject(new Error('Solo puedes subir imagenes de máximo 5 Mb'));
      return;
    }
    try {
      Resizer.imageFileResizer(
        file,
        maxWidth,
        maxHeight,
        'JPEG',
        quality,
        0,
        (uri) => resolve(uri),
        'file',
        200,
        200
      );
    } catch (error) {
      reject(error);
    }
  });

export const fileChangedHandler = (
  event,
  set_image,
  Swal,
  _resizer,
  _image,
  set_imagePreview = () => {}
) => {
  const file = event.target.files?.[0];
  if (!file) return;

  const targetID = event.target.id || '';
  const size = targetID.includes('document') ? 600 : 450;

  resizeImageFile(file, { maxWidth: size, maxHeight: size })
    .then((uri) => set_image(uri))
    .catch((error) => {
      Swal.fire(error.message);
    });

  if (IMAGE_EXTS.includes(String(file.name).split('.').pop().toLowerCase())) {
    set_imagePreview(URL.createObjectURL(file));
  }
};
